import React, { useRef, useState } from "react";
import Select from "react-select";
import Spacing from "../Spacing";
import { useSelector } from "react-redux";
import classNames from "classnames";
import DropdownWithSearch from "../DropdownWithSearch";
import Button from "../UI/Button";
import { can_visit, notify } from "../../helpers";
import { Drawer } from 'vaul';

export default function InviteUserModal(props) {
  const { allProviders, open, closeDialog, handleSubmit = () => {}, userRoles = [] } = props;
  const userProfileData = useSelector((state) => state.practice.userProfile);

  const [invitedUserData, setInvitedUserData] = useState({
    email: "",
    roles: [],
    groups: [],
    linked_providers: [],
  });
  const [validateInput, setValidateInput] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const dropdownRef = useRef(null); 
  

  const handleLinkedProvidersChange = (selectedOption) => {
    const selectedValues = selectedOption ? selectedOption.map((option) => option.value) : [];    
    setInvitedUserData({
      ...invitedUserData,
      linked_providers: selectedValues,
    });
  };



  const handleChange = (e) => {
    setInvitedUserData({
      ...invitedUserData,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeRoles = (value) => {
    setInvitedUserData({
      ...invitedUserData,
      roles: invitedUserData.roles.includes(value)
        ? invitedUserData.roles.filter((role) => role !== value)
        : [...invitedUserData.roles, value],
    });
  };

  const handleSelectGroup = (account) => {
    const accountKey = `/${account?.practices[0]?.account_name}`;
    const practiceKeys = account.practices.map((practice) => `${accountKey}/${practice.name}`);
  
    setInvitedUserData((prevData) => {
      const isAccountSelected = prevData.groups.includes(accountKey);

      if (isAccountSelected) {
        return {
          ...prevData,
          groups: prevData.groups.filter(
            (group) => group !== accountKey && !practiceKeys.includes(group)
          ),
        };
      }

      return {
        ...prevData,
        groups: [...new Set([...prevData.groups, accountKey, ...practiceKeys])],
      };
    });
  };

  const handleChangePractices = (practiceName, accountName) => {
    const practiceKey = `/${accountName}/${practiceName}`;
    const accountKey = `/${accountName}`;
  
    setInvitedUserData((prevData) => {
      const isPracticeSelected = prevData.groups.includes(practiceKey);

      if (isPracticeSelected) {
        const updatedGroups = prevData.groups.filter((group) => group !== practiceKey);

        const hasRemainingPractices = updatedGroups.some((group) =>
          group.startsWith(`${accountKey}/`)
        );
  
        return {
          ...prevData,
          groups: hasRemainingPractices
            ? updatedGroups
            : updatedGroups.filter((group) => group !== accountKey),
        };
      }

      return {
        ...prevData,
        groups: [...new Set([...prevData.groups, practiceKey, accountKey])],
      };
    });
  };

  const handleInviteUser = () => {
    const selectedAccounts = userProfileData.accounts.filter((acc) =>
      acc.practices.some((practice) =>
        invitedUserData.groups.some((group) => group.startsWith(`/${practice.account_name}`))
      )
    );

    if (!invitedUserData?.roles || invitedUserData?.roles?.length === 0) {
      notify("error", "Please select at least one role");
      setValidateInput(true);
      return;
    }

    if (selectedAccounts?.length === 0) {
      notify("error", "Please select at least one practice");
      setValidateInput(true);
      return;
    }

    const checkEmpty = Object?.values(invitedUserData)?.some((x) => x === "");
    if (checkEmpty) {
      setValidateInput(true);
      return;
    }

    invitedUserData.groups = invitedUserData?.groups?.map((group) => {
      const parts = group?.split("/");
      return parts?.length > 1 ? `/${parts?.slice(1)?.join("/")}` : `/${parts[0]}`;
    });

    setLoading(true);
    handleSubmit(invitedUserData, () => {
      setLoading(false);
    });
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={open} onOpenChange={closeDialog}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 medium">
            <Drawer.Title className="sr-only">Invite User</Drawer.Title>
            <Drawer.Description className="sr-only">Invite a new user</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_auto">
              <div className="docpro_modal modal_height_100">
                <div>
                  <h2 className="docpro_fs_24">Invite a new user</h2>

                  <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_1">
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Email Address <span className="docpro_red_color">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        className={classNames("docpro_form_field size_lg", {
                          danger_alert:
                            validateInput && invitedUserData.email === "",
                        })}
                        onChange={handleChange}
                        placeholder="Enter email address"
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Role <span className="docpro_red_color">*</span>
                      </label>
                      <DropdownWithSearch
                        placeholder={
                          (invitedUserData?.roles && invitedUserData?.roles?.length)
                            ? `${invitedUserData?.roles.join(", ")}`
                            : "Select Roles"
                        }
                        isErrorState={validateInput && !invitedUserData?.roles?.length}
                      >
                        <ul className="docpro_checkmark_list">
                          {(can_visit("administrator") ? userRoles : userRoles?.filter(
                            (role) => !["Trial", "System", "Enterprise"].includes(role)
                            ))?.map((item, index) => (
                              <li key={index}>
                                <div className="docpro_checkbox" style={{ top: "3px" }}>
                                  <input
                                    type="checkbox"
                                    checked={invitedUserData?.roles?.includes(item)}
                                    onChange={() => handleChangeRoles(item)}
                                  />
                                  <label>
                                    <span style={{ marginLeft: "8px" }}>{item}</span>
                                  </label>
                                </div>
                              </li>
                            )
                          )}
                        </ul>
                      </DropdownWithSearch>
                    </div>

                    

                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Practices <span className="docpro_red_color">*</span>
                      </label>
                      <DropdownWithSearch
                        placeholder={
                          invitedUserData?.groups?.length
                            ? `${invitedUserData?.groups?.join(", ")}`
                            : "Select Practices"
                        }
                        isErrorState={validateInput && !invitedUserData?.groups?.length}
                      >
                        {userProfileData?.accounts?.map((account, index) => (
                          <div key={index}>
                            <li style={{ listStyle: "none", margin: "10px 0px" }}>
                              <div
                                className="docpro_checkbox"
                                style={{ top: "3px" }}
                              >
                                <input
                                  type="checkbox"
                                  onChange={() => handleSelectGroup(account)}
                                  checked={invitedUserData?.groups?.includes(
                                    `/${account?.practices[0]?.account_name}`
                                  )}
                                />
                                <label>
                                  <span style={{ marginLeft: "8px" }}>
                                    {account?.practices[0]?.account_name}
                                  </span>
                                </label>
                              </div>
                            </li>
                            {account.practices.map((practice) => {
                              const practiceKey = `/${account?.practices[0]?.account_name}/${practice.name}`;
                              return (
                                <li
                                  key={practice?.location_id}
                                  style={{ listStyle: "none", paddingLeft: "15px" }}
                                >
                                  <div
                                    className="docpro_checkbox"
                                    style={{ top: "3px" }}
                                  >
                                    <input
                                      type="checkbox"
                                      onChange={() => handleChangePractices(practice?.name, account?.practices[0]?.account_name)}
                                      checked={invitedUserData?.groups?.includes(practiceKey)}
                                    />
                                    <label>
                                      <span style={{ marginLeft: "8px" }}>
                                        {practice?.name}
                                      </span>
                                    </label>
                                  </div>
                                </li>
                              )
                            })}
                          </div>
                        ))}
                      </DropdownWithSearch>
                    </div>

                    {allProviders?.length > 0 && (
                      <div className="docpro_grid_item">
                        <label className="docpro_fw_500 docpro_primary_color">
                          Linked Providers
                        </label>
                        <Select
                          isMulti
                          name="linked_providers"
                          options={allProviders?.map((provider) => ({
                            label: `${provider?.first_name} ${provider?.last_name}`,
                            value: provider?.provider_id
                          }))}
                          placeholder="Search..."
                          isSearchable
                          value={invitedUserData?.linked_providers?.map(providerId => {
                            const provider = allProviders?.find(p => p.provider_id === providerId);
                            return provider ? {
                              label: `${provider.first_name} ${provider.last_name}`,
                              value: provider.provider_id
                            } : null;
                          }).filter(Boolean) || []}
                          onChange={(selectedOption) => handleLinkedProvidersChange(selectedOption)}
                          className="react-select-container w-full"
                          classNamePrefix="react-select"
                          styles={{
                            control: (base) => ({
                              ...base,
                              minHeight: '40px',
                              borderColor: 'var(--border)',
                              borderRadius: '8px'
                            }),
                            menu: (base) => ({
                              ...base,
                              zIndex: 1050,
                              marginTop: '-2px',
                              borderRadius: '0 0 3px 3px',
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 1050,
                              padding: 0
                            }),
                          }}
                        />
                      </div>
                    )}

                    
                  </div>
                  <Spacing lg="32" sm="32" />
                </div>
                <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                  <button
                    className="docpro_bordered_btn docpro_fw_600 size_lg"
                    onClick={closeDialog}
                  >
                    Cancel
                  </button>
                  <Button filled lg loading={loading} onClick={handleInviteUser}>
                    Invite
                  </Button>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
